import React, { Component } from 'react';
import SurveyRect from './Shared/SurveyRect';
import FormatText from '../Utils/TextFormatter';
import MultiAns from './Shared/MultiAns';
import Timer from './Shared/Timer';
import Button from './Shared/Button';
import shuffleAnswers from '../Utils/ShuffleAnswers';

export default class MultipleChoicePage extends Component {

    state = {
        isCurrent: false,
        ansInx:-1,
        qKey:"",
        answers:[],
        selectedAnswers:[],
        timerIsDone: false,
        phase:1,
    }

    componentDidUpdate(){
        const {isCurrent, answers} = this.props;
        if(this.state.isCurrent !== isCurrent){               
            this.setState({isCurrent:isCurrent});
        }

        //Updating answers preview during backoffice editing:
        if(this.state.answers !== answers){
            this.setState({answers:answers})
        }
    }

    componentDidMount(){
        const {readingTime, answers, randomizeOrder} = this.props;

        let _answers = [];
        answers.forEach((ans)=>{
            _answers.push({...ans, isSelected:false});
        });

        this.setState({selectedAnswers: _answers});

        // console.log(`[+]\t readingTime = ${readingTime}`)
        if(readingTime === 0) {
            this.setState({timerIsDone: true});
        }

        if(randomizeOrder) {this.setState({answers:shuffleAnswers(answers)})}
        else {this.setState({answers:answers})}

    }

    shuffleAnswers(){

    }


    render(){
        const {style, qKey, preface, question, qTextSize, readingTime, ansSpacing, ansTxtSize, columns, hasSecondPhase, altButtonTitle1, altButtonTitle2} = this.props;
        const {phase, timerIsDone, answers, selectedAnswers} = this.state;
        // const answers = JSON.parse(this.props.answers)
        // console.log(`[++]\t qKey = ${qKey} readingTime = ${readingTime}, isCurrent = ${this.state.isCurrent}, timerIsDone = ${this.state.timerIsDone}`)

        const buttonText1 = (altButtonTitle1 !== "" && altButtonTitle1 !== undefined) ? altButtonTitle1 : "הצגת אפשרויות";
        const buttonText2 = (altButtonTitle2 !== "" && altButtonTitle2 !== undefined) ? altButtonTitle2 : "המשך";


        const padding = 28;
        let spacing = 60; 
        if(ansSpacing === 'spacious') spacing = 80;
        if(ansSpacing === 'narrow') spacing = 40;
        
        let questionText;
        if(qTextSize === `small`){ 
            questionText = <div className="smallQuestion">{FormatText(global.isMale,question)}</div>
        }
        if(qTextSize === `medium`){ 
            questionText = <h3>{FormatText(global.isMale,question)}</h3>
        }
        if(qTextSize === `large`){ 
            questionText = <h2>{FormatText(global.isMale,question)}</h2>
        }

		return <div style={style}>
            <SurveyRect {...this.props} H={phase === 1 ? 440 : 500}>
                <div  style={{
                    position: "absolute",
                    right: padding,
                    left: padding,
                    top: padding,
                    bottom: 0,
                    overflow: "scrollY",
                    textAlign: "right",
                }}>
                    <div id="phase1_container" style={{display: phase === 1 ? '':'none'}}>
                        {(preface !== ``) && <div className="preface">{FormatText(global.isMale,preface)}</div>}
                        {questionText}
                        <div className="separation-bar"/>
                    </div>
                    <div id="multi_ans_container" style={{
                        position: "absolute",
                        opacity: hasSecondPhase ? phase === 2 ? 1 : 0   :   timerIsDone ? 1 : 0,
                        pointerEvents: hasSecondPhase ? phase === 2 ? "":"none"    :    timerIsDone ? "":"none",
                        transition: "opacity 0.3s ease-out",
                        bottom: 84,
                        right: 0,
                        left: 0,
                        top:0,
                        display: "flex",
                        justifyContent: "flex-start",
                    }}>
                        {                            
                            answers.map((_ans,i)=> {
                                const ansTxt = FormatText(global.isMale,_ans.ans);
                                const isSelected = selectedAnswers[i] !== undefined ? selectedAnswers[i]["isSelected"] : false;
                                                                                          
                                return <MultiAns key={i} txt={ansTxt} 
                                    H={40} W={columns ==="two" ? "50%" : "100%"} B={this.calculateAnsPos(answers.length, i, spacing, columns)} col={(columns ==="two" && (i-1)%2 === 0) ? 2 : 1}
                                    isChoosen={isSelected}
                                    isOpenAns={_ans.isOpen}
                                    isMultipleChoice={true}
                                    ansTxtSize={ansTxtSize}
                                    qKey={qKey}
                                    onClick={(value)=>{
                                        let newAnswers = selectedAnswers;
                                        if(_ans.isOpen) {
                                            if(value === "isSelecting"){
                                                newAnswers[i]["isSelected"] = !isSelected;
                                                newAnswers[i]["ans"] = "";
                                            } else {
                                                newAnswers[i]["ans"] = value;
                                            }
                                        } else {
                                            newAnswers[i]["isSelected"] = !isSelected;
                                        } 

                                        this.setState({selectedAnswers:newAnswers});
                                    }}
                                />
                        })}
                        <div id="show_question" style={{
                            position:"absolute",
                            right:0,
                            bottom:-48,
                            width: 28,
                            height: 28,
                            borderRadius: "100%",
                            backgroundColor: phase === 2 ? global.colorTheme.main : global.colorTheme.secondaryLight,
                            cursor: 'pointer',
                            display: hasSecondPhase ? 'flex' : 'none',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: 20,
                            color: 'white',
                        }} onClick={()=>{this.setState({phase:1})}}>?</div>
                    </div>
                </div>
                {readingTime > 0 && <Timer duration={readingTime} startCount={this.state.isCurrent} callBack={()=>{this.setState({timerIsDone:true})}}/>}
                <Button style={{
                    position:"absolute",
                    left:padding,
                    bottom:padding,
                }} text={hasSecondPhase ? phase === 1 ? buttonText1 : buttonText2    :    buttonText2} isActive={this.validate(hasSecondPhase, phase, timerIsDone)} onClick={() => {
                    if(hasSecondPhase) {
                        if(phase === 1){
                            this.setState({phase:2});
                        }
                        if(phase === 2){
                            this.SetAnswer();
                        }
                    } else {
                        this.SetAnswer();
                    }
                }}/>
            </SurveyRect>
        </div>
    }


    calculateAnsPos(numAns, inx, spacing, col) {
        if(col === "one") {
            return (numAns-inx-1)*spacing;
        }

        if(col === "two") {
            const odd = (numAns - 1) % 2; 
            return ( Math.floor((numAns-inx-odd)/2))*spacing;
        }
    }

    validate(hasSecondPhase, phase, timerIsDone) {
        if(hasSecondPhase){
            if(phase === 1 && timerIsDone){
                return true;
            }
    
            if(phase === 2){
                let selected = 0;
                this.state.selectedAnswers.forEach((a)=>{
                    if(a.isSelected && a["ans"]!=="") selected++;
                });
                return selected > 0;
            }
        } else {
            let selected = 0;
            this.state.selectedAnswers.forEach((a)=>{
                if(a.isSelected && a["ans"]!=="") selected++;
            });
            return selected > 0;
        }
    }

    SetAnswer()
    {
        this.state.selectedAnswers.forEach((ans)=>{
            if(ans.isOpen) {
                global.setAnswer(`${this.props.qKey}_OPEN`, ans.ans);
            } else {
                global.setAnswer(`${this.props.qKey}_${ans.key}`, ans.isSelected);
            }
        });
        global.nextStage(this.props.followingScreen);
    }
}


// WEBPACK FOOTER //
// ./src/Comp/MultipleChoicePage.js